import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Use React 18+ createRoot API
const root = ReactDOM.createRoot(rootElement);
root.render(app);
